<template>
  <div class="main">
    <div class="banner"></div>
    <div class="banner-text">
      <div class="l">思维启蒙课</div>
      <div class="r">
        <div class="new-price">
          <div class="yuan">￥</div>
          <div class="price">299</div>
        </div>
        <div class="old-price">
          <div class="yuan">￥</div>
          <div class="price">599</div>
        </div>
      </div>
    </div>
    <div class="main-one"></div>
    <div class="main-two"></div>
    <div class="main-three"></div>
    <div class="main-four"></div>
    <div class="main-five"></div>
    <div class="main-six"></div>
    <div class="footer">
      <div class="btn" @click="buy">立即购买</div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    getUrlParam (name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
      let r = window.location.search.substr(1).match(reg)
      if (r != null) {
        return unescape(r[2])
      }
      return null
    },
    getWxCode () {
      let appid = "wx3dcc8b8f8d8bf78b" //为测试号id
      let local = `http://jimuaike.com/wap/#/newOrder?classId=${this.classId}&channelType=1`
      let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_base&state=1#wechat_redirect`
      window.location.replace(url)
    },
    buy () {
      this.classId = this.$route.query.classId || 128
      this.getWxCode()
    },
  },
}
</script>

<style scoped lang='less'>
.main {
  padding-bottom: 140px;
  background: #f4f4f4;
  .banner {
    height: 420px;
    background: url("./banner.png") no-repeat;
    background-size: cover;
  }
  .banner-text {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 112px;
    padding: 0 32px;
    background: #fff;
    .l {
      font-size: 34px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
    }
    .r {
      display: flex;
      align-items: center;
      .new-price {
        display: flex;
        align-items: baseline;
        .yuan {
          font-size: 28px;
          font-family: SFProDisplay-Regular, SFProDisplay;
          font-weight: 400;
          color: #ff5330;
          line-height: 34px;
        }
        .price {
          font-size: 40px;
          font-family: SFProDisplay-Medium, SFProDisplay;
          font-weight: 500;
          color: #ff5330;
          line-height: 48px;
        }
      }
      .old-price {
        display: flex;
        align-items: baseline;
        padding-left: 16px;
        .yuan {
          font-size: 28px;
          font-family: SFProDisplay-Regular, SFProDisplay;
          font-weight: 400;
          color: #999999;
          line-height: 34px;
        }
        .price {
          font-size: 28px;
          font-family: SFProDisplay-Regular, SFProDisplay;
          font-weight: 400;
          color: #999999;
          line-height: 34px;
        }
      }
    }
  }
  .main-one {
    margin-top: 20px;
    height: 1075px;
    background: url("./main1.png") no-repeat;
    background-size: cover;
  }
  .main-two {
    margin-top: 20px;
    height: 1319px;
    background: url("./main2.png") no-repeat;
    background-size: cover;
  }
  .main-three {
    margin-top: 20px;
    height: 597px;
    background: url("./main3.png") no-repeat;
    background-size: cover;
  }
  .main-four {
    margin-top: 20px;
    height: 1161px;
    background: url("./main4.png") no-repeat;
    background-size: cover;
  }
  .main-five {
    margin-top: 20px;
    height: 1618px;
    background: url("./main5.png") no-repeat;
    background-size: cover;
  }
  .main-six {
    margin-top: 20px;
    height: 773px;
    background: url("./main6.png") no-repeat;
    background-size: cover;
  }
  .footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 690px;
      height: 90px;
      background: #0293de;
      border-radius: 45px;
      font-size: 34px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }
  }
}
</style>
